module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/pc/item_01_5be8d35e2a4120340e2348ed6970f411.jpg";